import { getInvoices, getCards, getSubscription } from 'lib/api';
import { BILLING_ACTIONS } from './billingReducer';
import { GlobalAction } from '.';

const {
  GET_BILLING_OVERVIEWS_START,
  GET_BILLING_OVERVIEWS_ERROR,
  GET_BILLING_OVERVIEWS_SUCCESS,
  GET_BILLING_INVOICES_START,
  GET_BILLING_INVOICES_ERROR,
  GET_BILLING_INVOICES_SUCCESS,
  GET_BILLING_CARDS_START,
  GET_BILLING_CARDS_ERROR,
  GET_BILLING_CARDS_SUCCESS,
} = BILLING_ACTIONS;

type LoadBillingParams = {
  params: any;
  dispatch: React.Dispatch<GlobalAction>;
};

export const loadBillingInvoices = async ({
  params,
  dispatch,
}: LoadBillingParams): Promise<void> => {
  dispatch({ type: GET_BILLING_INVOICES_START });
  const response = await getInvoices(params).catch((err: any) => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_BILLING_INVOICES_ERROR,
      error: response.message,
    });
    return;
  }

  dispatch({
    type: GET_BILLING_INVOICES_SUCCESS,
    payload: {
      invoices: { items: response.invoices || [] },
      hasMore: response.hasMore,
    },
  });
};

export const loadCards = async ({
  params,
  dispatch,
}: LoadBillingParams): Promise<void> => {
  dispatch({ type: GET_BILLING_CARDS_START });
  const response = await getCards(params).catch((err: any) => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_BILLING_CARDS_ERROR,
      error: response.message,
    });
    return;
  }

  dispatch({
    type: GET_BILLING_CARDS_SUCCESS,
    payload: {
      cards: { items: response.methods || [] },
      hasMore: response.hasMore,
    },
  });
};

export const loadSubscription = async ({ dispatch }: any): Promise<void> => {
  dispatch({ type: GET_BILLING_OVERVIEWS_START });
  const response = await getSubscription().catch((err: any) => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_BILLING_OVERVIEWS_ERROR,
      error: response.message,
    });
    return;
  }

  dispatch({
    type: GET_BILLING_OVERVIEWS_SUCCESS,
    payload: {
      subscription: {
        card: response.card || {},
        plan: response.plan || {},
        upcomingInvoice: response.upcomingInvoice || {},
        totalActiveUsers: response.totalActiveUsers || 0,
        totalAllowedUsers: response.totalAllowedUsers || 0,
        addons: response.addons || [],
        cancelAt: response.cancelAt || null,
        currentPeriodEnd: response.currentPeriodEnd || null,
        nextPeriodStart: response.nextPeriodStart || null,
      },
    },
  });
};
